import { render, staticRenderFns } from "./DialogCancelAccount.vue?vue&type=template&id=7d71a51f"
import script from "./DialogCancelAccount.vue?vue&type=script&lang=js"
export * from "./DialogCancelAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports